// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5s-1";
export var standaloneTable = "_5s-0";